// 个人中心

// 我的活动
const MyActivities = r => require.ensure(
  [],
  () => r(require('@/components/personal-center/my-activities/my-activities.vue')),
  'PersonalCenter'
)
// 个人中心
const ProjectList = r => require.ensure(
  [],
  () => r(require('@/components/personal-center/project-list/project-list.vue')),
  'PersonalCenter'
)

export default [
  // 我的活动
  {
    path: '/PersonalCenter/MyActivities',
    name: 'MyActivities',
    component: MyActivities
  },
  // 项目列表
  {
    path: '/PersonalCenter/ProjectList',
    name: 'ProjectList',
    component: ProjectList
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/personal-center.js